<template>
	<div class="app">
		<div class="main" id="main">
			<div class="mainTop">
				<div class="topLeft">
				</div>
				<div class="topCenter">
					<div class="title">隐患统计</div>
					<div style="display: flex;align-items: center;justify-content: center;">
						<img src="../../../assets/service_center/echartsPage/title.gif"
							style=" width: 80%; margin-left: 8%; ">
					</div>
				</div>
				<div class="topRight">

					<div style="width: 42px;height: 42px;cursor: pointer;margin-right: 4px; background: #616161; border-radius: 50%"
						@click="logout">
						<img src="../../../assets/service_center/echartsPage/left1.png" alt="" style="width: 100%;"
							title="退出">
					</div>

					<div style="width: 42px;height: 42px;cursor: pointer;margin-right: 20px; background: #616161; border-radius: 50%"
						id="theme" @click="themesState=true">
						<img src="../../../assets/service_center/echartsPage/theme.png" alt="" style="width: 100%;"
							title="更换主题">
					</div>
				</div>
			</div>
			<div class="mainCenter">
				<div class="left">
					<div class="leftTop chartImg" style="position: relative;">
						<p style="position: absolute;left: 25%;top: 20px;font-size: 16px;color: #ED5D13;">当前异常次数统计
						</p>
						<div class="echartBox">
							<div class="echart1" style="cursor:pointer;">
								<div class="echartBorder" id="echart1"></div>
								<div style="padding-top: 5px;">过流异常次数</div>
							</div>
							<div class="echart2" style="cursor:pointer;">
								<div class="echartBorder" id="echart2"></div>
								<div style="padding-top: 5px;">漏电异常次数</div>
							</div>
							<div class="echart3" style="cursor:pointer;">
								<div class="echartBorder" id="echart3"></div>
								<div style="padding-top: 5px;">欠压异常次数</div>
							</div>
							<div class="echart4" style="cursor:pointer;">
								<div class="echartBorder" id="echart4"></div>
								<div style="padding-top: 5px;">过压异常次数</div>
							</div>
						</div>
					</div>
					<div class="leftBottom chartImg" style="position: relative;">
						<p style="position: absolute;left: 25%;top: 20px;font-size: 16px;color: #ED5D13;">漏电异常次数统计</p>
						<div id="echartLeftBottom"></div>
					</div>
				</div>
				<div class="center">
					<baidu-map class="map" center="杭州" :mapType="mapType" :zoom="12" :scroll-wheel-zoom="true">
						<bm-control anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :offset="offset">
							<div @click="switchType" v-if="mapType == 'BMAP_HYBRID_MAP'" class="mapTypeBox"></div>
							<div @click="switchType" v-else class="mapTypeBoxEarth"></div>
						</bm-control>
						<bm-marker v-for="item in DeviceMapList" :key="item.Id" :position="{lng: item.Jd, lat: item.Wd}"
							:icon=" item.DeviceStatus == '0' ? changeIcon1 :
									(item.DeviceStatus == '1' && (item.KaiguanStatus == '0' || item.KaiguanStatus == '2') && item.AbStatus != '1') ? changeIcon2 :
									(item.DeviceStatus == '1' && (item.KaiguanStatus == '1' || item.KaiguanStatus == '2') && item.AbStatus != '1') ? changeIcon3 :
									(item.DeviceStatus == '1' && (item.KaiguanStatus == '0' || item.KaiguanStatus == '2') && item.AbStatus == '1') ? changeIcon5 : changeIcon4">
							<bm-label :content="item.DeviceName" :labelStyle="{color: 'red', fontSize : '12px'}" :offset="{width: 20, height: 5}"/>
						</bm-marker>
					</baidu-map>
				</div>
				<div class="right">
					<div class="rightTop chartImg" style="position: relative;">
						<p style="position: absolute;left: 25%;top: 20px;font-size: 16px;color: #ED5D13;">异常类型占比统计</p>
						<div id="echartRightTop"></div>
						<div
							style="position: absolute;color: #FFFFFF;top: 46%;left: 46%;font-size: 0.6vw;text-align: center;">
							<div style="font-weight: bold;font-size: 1vw">{{rightTopSum}}</div>
							<div>异常次数统计</div>
						</div>
					</div>
					<div class="rightBottom chartImg" style="position: relative;">
						<p style="position: absolute;left: 25%;top: 20px;font-size: 16px;color: #ED5D13;">过压异常及次数统计</p>
						<div id="echartRightBottom"></div>
					</div>
				</div>
			</div>
			<div class="mainBottom">
				<ul>
					<li class="itemImg" style="cursor:pointer;" @click="popupClick('GetDeviceList', 2, '过流异常')">
						<div style="font-size: 16px; margin-top: 14px">设备总数统计</div>
						<div class="itemImgText" id="itemImg1">0</div>
					</li>
					<li class="itemImg" style="cursor:pointer;" @click="popupClick('getAbTypeDataList', 2, '过流异常')">
						<div style="font-size: 16px; margin-top: 14px">过流异常统计</div>
						<div id="itemImg2" class="itemImgText">0</div>
					</li>
					<li class="itemImg" style="cursor:pointer;" @click="popupClick('getAbTypeDataList', 2, '过压异常')">
						<div style="font-size: 16px; margin-top: 14px">过压异常统计</div>
						<div id="itemImg3" class="itemImgText">0</div>
					</li>
					<li class="itemImg" style="cursor:pointer;" @click="popupClick('getAbTypeDataList', 2, '欠压异常')">
						<div style="font-size: 16px; margin-top: 14px">欠压异常统计</div>
						<div id="itemImg4" class="itemImgText">0</div>
					</li>
					<li class="itemImg" style="cursor:pointer;" @click="popupClick('getAbTypeDataList', 2, '温度异常')">
						<div style=" font-size: 16px; margin-top: 14px">温度异常统计</div>
						<div id="itemImg5" class="itemImgText">0</div>
					</li>
					<li class="itemImg" style="cursor:pointer;" @click="popupClick('getAbTypeDataList', 2, '漏电异常')">
						<div style="font-size: 16px; margin-top: 14px">漏电异常统计</div>
						<div id="itemImg6" class="itemImgText">0</div>
					</li>
					<li class="itemImg" style="cursor:pointer;" @click="popupClick('getAbTypeDataList', 2, '三相不平衡')">
						<div style="font-size: 16px; margin-top: 14px">三相不平衡统计</div>
						<div id="itemImg7" class="itemImgText">0</div>
					</li>
					<li class="itemImg" style="cursor:pointer;" @click="popupClick('getAbTypeDataList', 2, '维护模式')">
						<div style="font-size: 16px; margin-top: 14px">维护模式统计</div>
						<div id="itemImg8" class="itemImgText">0</div>
					</li>
				</ul>
			</div>
			<div class="border-left">
				<div class="mask">
					<div class="twinklingBorder"></div>
				</div>
			</div>
			<div class="border-right">
				<div class="mask">
					<div class="twinklingBorder"></div>
				</div>
			</div>
			<div class="border-bottomLeft">
				<div class="mask">
					<div class="twinklingBorder"></div>
				</div>

			</div>
			<div class="border-bottomRight">
				<div class="mask">
					<div class="twinklingBorder"></div>
				</div>
			</div>
		</div>

		<div class="theme-mode" v-if="themesState" @click="themesState=false">
			<div class="theme-div" @click.stop="">
				<div class="theme-img">
					<img src="../../../assets/service_center/echartsPage/up.png" />
				</div>
				<div class="theme-view">
					<div class="theme-view-lists">
						<div class="theme-view-list" v-for="theme in themes" :key="theme.id"
							:style="'background-color:'+theme.color+' ;'" :title="theme.title"
							@click="switchClick(theme)" :class="{'theme-view-list-select':theme.id == selectTheme.id}">
							<img v-if="theme.image" :src="theme.image" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="app">
			<div class="app-pupop-mode" v-if="popupState" v-on:click="popupState=false">
				<div class="app-pupop" v-on:click.stop="">
					<dv-border-box-11 background-color="rgba(7,22,55, 0.7)" :title="popupTitle">
						<div class="outline-mode" v-if="popupType == 'GetDeviceList'">
							<div class="map-bottom-content-tab">
								<div class="map-bottom-content-tab-item1">设备编号</div>
								<div class="map-bottom-content-tab-item1">设备名称</div>
								<div class="map-bottom-content-tab-item1">城市</div>
								<div class="map-bottom-content-tab-item1">具体地址</div>
								<div class="map-bottom-content-tab-item1 tabHandle1">状态</div>
							</div>
							<div class="map-bottom-list">
								<div id="content" class="map-bottom-lists" v-if="LoadBjDeviceLists.length > 0">
									<div class="map-bottom-list-item1" v-for="item in LoadBjDeviceLists" :key="item.Id">
										<div class="map-bottom-list-item-device">{{item.DeviceCode}}</div>
										<div class="map-bottom-list-item-addr">{{item.DeviceName}}</div>
										<div class="map-bottom-list-item-date">{{item.City}}</div>
										<div class="map-bottom-list-item-date">{{item.Address}}</div>
										<div class="map-bottom-list-item-handle1">
											<img v-if="item.DeviceStatus == '1'" src="../../../assets/service_center/echartsPage/lvse.png"/>
											<img v-else-if="item.DeviceStatus == '0'" src="../../../assets/service_center/echartsPage/huise.png" />
											<span v-else>其它</span>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-if="LoadBjDeviceLists.length == 0">暂无数据</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="totalCount" :styles="styles" size="small" v-on:on-change="DeviceChange"
									v-on:on-page-size-change="DeviceSizeChange" show-total show-elevator show-sizer
									placement="top" />
							</div>
						</div>

						<div class="outline-mode" v-else>
							<div class="map-bottom-content-tab">
								<div class="map-bottom-content-tab-item">设备编号</div>
								<div class="map-bottom-content-tab-item">异常码类别</div>
								<div class="map-bottom-content-tab-item">异常码名称</div>
								<div class="map-bottom-content-tab-item">发生异常时间</div>
								<div class="map-bottom-content-tab-item tabHandle">当前值</div>
								<div class="map-bottom-content-tab-item tabHandle">当前阈值</div>
								<div class="map-bottom-content-tab-item tabHandle">差值</div>
							</div>
							<div class="map-bottom-list">
								<div id="content" class="map-bottom-lists" v-if="LoadBjDeviceLists.length > 0">
									<div class="map-bottom-list-item" v-for="(item) in LoadBjDeviceLists"
										:key="item.Id">
										<div class="map-bottom-list-item-device">{{item.DeviceCode}}</div>
										<div class="map-bottom-list-item-addr">{{item.ParameterName}}</div>
										<div class="map-bottom-list-item-date">{{item.AbnormalName}}</div>
										<div class="map-bottom-list-item-date">{{item.AbnormalDate | formDate}}</div>
										<div class="map-bottom-list-item-handle">{{item.CurrentValue}}</div>
										<div class="map-bottom-list-item-handle">{{item.RatedValue}}</div>
										<div class="map-bottom-list-item-handle">{{item.BalaceValue}}</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-if="LoadBjDeviceLists.length == 0">暂无数据</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="totalCount" :styles="styles" size="small" v-on:on-change="DeviceChange"
									v-on:on-page-size-change="DeviceSizeChange" show-total show-elevator show-sizer
									placement="top" />
							</div>
						</div>
					</dv-border-box-11>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Echarts from 'echarts'
	import Cookies from 'js-cookie'
	import $ from 'jquery'
	import api from '../../../api/ros_request.js'
	export default {
		data() {
			return {
				popupState: false,
				popupTitle: '',
				popupType: '',
				styles: {
					color: '#fff'
				},
				pageIndex: 1,
				pageSize: 10,
				AbnormalName: "",
				AbnormalDate: "",
				totalCount: 0,
				LoadBjDeviceLists: [],
				DeviceGjCounts: {}, // 设备数量及告警数量
				rightTopSum: 0, // 异常次数统计
				mapType: 'BMAP_HYBRID_MAP', // 地图类型
				DeviceMapList: [], // 地图数据
				changeIcon1: {
					url: require("../../../assets/service_center/echartsPage/graymaker1.png"),
					size: {
						width: 100,
						height: 100
					}
				},
				changeIcon2: {
					url: require("../../../assets/service_center/echartsPage/greenmaker1.png"),
					size: {
						width: 100,
						height: 100
					}
				},
				changeIcon3: {
					url: require("../../../assets/service_center/echartsPage/redmaker1.png"),
					size: {
						width: 100,
						height: 100
					}
				},
				changeIcon4: {
					url: require("../../../assets/service_center/echartsPage/redmak.gif"),
					size: {
						width: 100,
						height: 100
					}
				},
				changeIcon5: {
					url: require("../../../assets/service_center/echartsPage/greenmak.gif"),
					size: {
						width: 100,
						height: 100
					}
				},

				offset: {
					width: 10,
					height: 10,
				},

				themesState: false, // 主题状态
				themes: [{
					id: 1,
					color: "#061436",
					title: "经典蓝",
					image: "",
					stateType: false
				}, {
					id: 2,
					color: "#000000",
					title: "黑色",
					image: "",
					stateType: false
				}, {
					id: 3,
					color: "",
					title: "夜色天空",
					image: require("../../../assets/service_center/echartsPage/indexbc.png"),
					stateType: true
				}, {
					id: 4,
					color: "",
					title: "科技星球",
					image: require("../../../assets/service_center/echartsPage/bg.jpg"),
					stateType: true
				}, {
					id: 5,
					color: "",
					title: "粒子宇宙",
					image: require("../../../assets/service_center/echartsPage/Homebodybg.png"),
					stateType: true
				}, {
					id: 6,
					color: "",
					title: "灿烂星空",
					image: require("../../../assets/service_center/echartsPage/map_bg.jpg"),
					stateType: true
				}],

				selectTheme: {},
			}
		},

		computed: {},

		mounted() {
			let _this = this;

			// 获取设备数量及告警数量
			_this.GetDeviceGjCount();

			// 告警占比
			_this.GetAbTypeZb();

			// 获取漏电异常次数统计
			_this.GetLdAbnormalCount();

			// 获取过压异常统计数据
			_this.GetGyAbnormalCount();

			// 获取地图设备列表
			_this.GetDeviceMaplist();

			// _this.initMap();

			// 获取储存的主题
			let theme = localStorage.getItem("theme");

			if (!theme) {
				_this.selectTheme = {
					id: 1,
					color: "#061436",
					title: "经典蓝",
					image: "",
					stateType: false
				}
			} else {
				_this.selectTheme = JSON.parse(theme);
			}

			if (_this.selectTheme.stateType) {
				document.getElementById('main').style.backgroundColor = '';
				document.getElementById('main').style.backgroundImage = `url(${_this.selectTheme.image})`;
			} else {
				document.getElementById('main').style.backgroundImage = ``;
				document.getElementById('main').style.backgroundColor = _this.selectTheme.color;
			}

		},

		methods: {
			// 获取设备数量及告警数量
			GetDeviceGjCount() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetDeviceGjCount',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.DeviceGjCounts = res.data.Data;
						_this.getNumScroll(res.data.Data);

						_this.$nextTick(function() {
							let Echart1 = Echarts.init(document.getElementById('echart1'));
							let Echart2 = Echarts.init(document.getElementById('echart2'));
							let Echart3 = Echarts.init(document.getElementById('echart3'));
							let Echart4 = Echarts.init(document.getElementById('echart4'));
							Echart1.setOption(_this.option_echart('过流异常', _this.DeviceGjCounts
								.GlAbnormalCount));
							Echart2.setOption(_this.option_echart('漏电异常', _this.DeviceGjCounts
								.LdAbnormalCount));
							Echart3.setOption(_this.option_echart('欠压异常', _this.DeviceGjCounts
								.QianyaCount));
							Echart4.setOption(_this.option_echart('过压异常', _this.DeviceGjCounts
								.GyAbnormalCount));
							window.addEventListener('resize', function() {
								Echart1.resize();
								Echart2.resize();
								Echart3.resize();
								Echart4.resize();
							});
							$('.echart1').on('click', function(params) {
								_this.popupClick('getAbTypeDataList', 2, '过流异常');
							});
							$('.echart2').on('click', function(params) {
								_this.popupClick('getAbTypeDataList', 2, '漏电异常');
							});
							$('.echart3').on('click', function(params) {
								_this.popupClick('getAbTypeDataList', 2, '欠压异常');
							});
							$('.echart4').on('click', function(params) {
								_this.popupClick('getAbTypeDataList', 2, '过压异常');
							});
						});
					}
				}).catch(function(err) {

				});
			},

			// 告警占比
			GetAbTypeZb() {
				let _this = this;
				api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'ShowData/Device/GetAbTypeZb',
						data: {
							CompanyCode: Cookies.get('ros_CompanyCode'),
							DepartmentCode: Cookies.get('ros_DepartmentCode'),
							GroupCode: Cookies.get('ros_GroupCode'),
							isAdmin: Cookies.get('ros_isAdmin')
						},
					}).then(function(res) {
						if (res.data.Success) {
							_this.GetAbTypeZbEchartsData(res.data.Data);
							res.data.Data.forEach(item => {
								_this.rightTopSum += item.value
							})
						}
					})
					.catch(err => { // 请求失败处理
						console.log(err);
					});
			},

			// 获取漏电异常次数统计
			GetLdAbnormalCount() {
				let _this = this;
				api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'ShowData/Device/GetLdAbnormalCount',
						data: {
							CompanyCode: Cookies.get('ros_CompanyCode'),
							DepartmentCode: Cookies.get('ros_DepartmentCode'),
							GroupCode: Cookies.get('ros_GroupCode'),
							isAdmin: Cookies.get('ros_isAdmin')
						},
					}).then(function(res) {
						if (res.data.Success) {
							_this.GetLdAbnormalCountEchartsData(res.data.Data.ldlistN, res.data.Data.ldlistV)
						}
					})
					.catch(err => { // 请求失败处理
						console.log(err);
					});
			},

			// 获取过压异常统计数据
			GetGyAbnormalCount() {
				let _this = this;
				api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'ShowData/Device/GetGyAbnormalCount',
						data: {
							CompanyCode: Cookies.get('ros_CompanyCode'),
							DepartmentCode: Cookies.get('ros_DepartmentCode'),
							GroupCode: Cookies.get('ros_GroupCode'),
							isAdmin: Cookies.get('ros_isAdmin')
						},
					}).then(function(res) {
						if (res.data.Success) {
							_this.GetGyAbnormalCountEchartsData(res.data.Data.gylistN, res.data.Data.gylistV)
						}
					})
					.catch(err => { // 请求失败处理
						console.log(err);
					});
			},

			// 地图设备列表
			GetDeviceMaplist() {
				let _this = this;
				api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'ShowData/Device/GetDevicelist',
						data: {
							CompanyCode: Cookies.get('ros_CompanyCode'),
							DepartmentCode: Cookies.get('ros_DepartmentCode'),
							GroupCode: Cookies.get('ros_GroupCode'),
							isAdmin: Cookies.get('ros_isAdmin'),
							pageIndex: 1,
							pageSize: 100
						},
					}).then(function(res) {
						if (res.data.Code == 0) {
							_this.DeviceMapList = res.data.Data;
						}
					})
					.catch(err => { // 请求失败处理
						console.log(err);
					});
			},

			// 地图类型切换
			switchType() {
				let _this = this;
				if (_this.mapType == 'BMAP_HYBRID_MAP') {
					_this.mapType = 'BMAP_NORMAL_MAP';
				} else {
					_this.mapType = 'BMAP_HYBRID_MAP'
				}
			},

			// initMap() {
			// 	let _this = this
			// 	let mapPoints = this.mapPoints

			// 	function mapType() {
			// 		this.defaultAnchor = 'BMAP_ANCHOR_BOTTOM_RIGHT';
			// 		this.defaultOffset = new BMap.Size(10, 10);
			// 	}

			// 	function hasClass(ele, name) {
			// 		let classNameList = ele.className.split(" ");
			// 		for (let i = 0; i < classNameList.length; i++) {
			// 			if (classNameList[i] == name) {
			// 				return true
			// 			}
			// 		}
			// 		return false
			// 	}

			// 	function markerFun(points, label, infoWindows, ico) {
			// 		var markers = new BMap.Marker(points, {
			// 			icon: ico
			// 		});
			// 		_this.map.addOverlay(markers);
			// 		markers.setLabel(label);
			// 		markers.addEventListener("mouseover", function(event) {
			// 			label.setStyle({
			// 				display: "block"
			// 			});
			// 		})
			// 		markers.addEventListener("mouseout", function(event) {
			// 			label.setStyle({
			// 				display: "none"
			// 			});
			// 		})
			// 		markers.addEventListener("click", function(event) {
			// 			_this.map.openInfoWindow(infoWindows, points); //参数:窗口、点  根据点击的点出现对应的窗口
			// 			_this.isShowPoint = true
			// 			let params = {
			// 				Jd: label.point.lng,
			// 				Wd: label.point.lat,
			// 				DeviceName: label.content
			// 			}
			// 		});
			// 	}

			// 	this.map = new BMap.Map("container", {
			// 		// enableMapClick: false
			// 	}) //新建地图实例，enableMapClick:false :禁用地图默认点击弹框
			// 	let point = new BMap.Point(120.208261, 30.257851);
			// 	this.map.centerAndZoom(this.city, 12);
			// 	this.map.setMapType(BMAP_HYBRID_MAP)
			// 	this.map.enableScrollWheelZoom(true); // 开启鼠标滚动模式
			// 	mapType.prototype = new BMap.Control();
			// 	mapType.prototype.initialize = function(map) {
			// 		// 创建一个DOM元素
			// 		var div = document.createElement("div");
			// 		var box = document.createElement("div");
			// 		box.className = "isFull"
			// 		div.className = "mapTypeBox"
			// 		// 绑定事件
			// 		div.onclick = function(e) {
			// 			let eDom = document.getElementsByClassName("mapTypeBox")[0]
			// 			if (hasClass(eDom, "normal")) {
			// 				map.setMapType(BMAP_HYBRID_MAP) // 设置为卫星模式
			// 				let newClassName = ""
			// 				let classList = div.className.split(" ")
			// 				classList.splice(classList.length - 1, 1)
			// 				classList.forEach((item, index) => {
			// 					newClassName += item + " "
			// 				})
			// 				div.className = newClassName.substring(0, newClassName.length - 1);
			// 			} else {
			// 				map.setMapType(BMAP_NORMAL_MAP) // 设置为普通模式
			// 				div.className += " normal";
			// 			}
			// 		}

			// 		box.onclick = function(e) {
			// 			let containerDom = document.getElementById("container")
			// 			var docElm = document.documentElement;
			// 			if (containerDom.className.indexOf("fullScreen") != -1) {
			// 				console.log("包含")
			// 				containerDom.className = "map"
			// 				document.exitFullscreen();
			// 			} else {
			// 				console.log("不包含")
			// 				containerDom.className += " fullScreen"
			// 				box.style.opacity = "0"
			// 				docElm.requestFullscreen();
			// 			}
			// 			map.centerAndZoom(_this.city, 8);
			// 		}

			// 		box.onmouseover = function() {
			// 			box.style.opacity = "1";
			// 		}

			// 		box.onmouseout = function() {
			// 			let containerDom = document.getElementById("container")
			// 			if (containerDom.className.indexOf("fullScreen") != -1) {
			// 				box.style.opacity = "0"
			// 			}
			// 		}

			// 		// 添加DOM元素到地图中
			// 		_this.map.getContainer().appendChild(box);
			// 		_this.map.getContainer().appendChild(div);
			// 		// 将DOM元素返回
			// 		return div;
			// 	}
			// 	// 创建控件实例
			// 	let newMapType = new mapType();
			// 	// 添加到地图当中
			// 	this.map.addControl(newMapType);

			// 	_this.map.enableScrollWheelZoom(true);
			// 	var changeIcon1 = new BMap.Icon(require("../../../assets/service_center/echartsPage/graymaker1.png"),
			// 		new BMap.Size(100, 100));
			// 	var changeIcon2 = new BMap.Icon(require("../../../assets/service_center/echartsPage/greenmaker1.png"),
			// 		new BMap.Size(100, 100));
			// 	var changeIcon3 = new BMap.Icon(require("../../../assets/service_center/echartsPage/redmaker1.png"),
			// 		new BMap.Size(100, 100));
			// 	var changeIcon4 = new BMap.Icon(require("../../../assets/service_center/echartsPage/redmak.gif"), new BMap
			// 		.Size(100, 100));
			// 	var changeIcon5 = new BMap.Icon(require("../../../assets/service_center/echartsPage/greenmak.gif"),
			// 		new BMap.Size(100, 100));

			// 	for (let i = 0; i < mapPoints.length; i++) {
			// 		var points = new BMap.Point(mapPoints[i].y, mapPoints[i].x); //创建坐标点
			// 		var opts = {
			// 			width: 400,
			// 			height: 200,
			// 			title: mapPoints[i].title
			// 		};
			// 		var label = new BMap.Label(mapPoints[i].branch, {
			// 			offset: new BMap.Size(25, 5)
			// 		});
			// 		label.setStyle({
			// 			display: "none"
			// 		});
			// 		var infoWindows = new BMap.InfoWindow(mapPoints[i].con, opts);

			// 		if (mapPoints[i].title == "0") {
			// 			markerFun(points, label, null, changeIcon1);
			// 		} else if (mapPoints[i].title == "1" && (mapPoints[i].con == "0" || mapPoints[i].con == "2") &&
			// 			mapPoints[i].bj != "1") {
			// 			markerFun(points, label, null, changeIcon2);
			// 		} else if (mapPoints[i].title == "1" && (mapPoints[i].con == "1" || mapPoints[i].con == "2") &&
			// 			mapPoints[i].bj != "1") {
			// 			markerFun(points, label, null, changeIcon3);
			// 		} else if (mapPoints[i].title == "1" && (mapPoints[i].con == "0" || mapPoints[i].con == "2") &&
			// 			mapPoints[i].bj == "1") {
			// 			markerFun(points, label, null, changeIcon5);
			// 		} else if (mapPoints[i].title == "1" && (mapPoints[i].con == "1" || mapPoints[i].con == "2") &&
			// 			mapPoints[i].bj == "1") {
			// 			markerFun(points, label, null, changeIcon4);
			// 		}
			// 	}
			// },

			// 刷新翻牌器
			getNumScroll(DeviceGjCounts) {
				let _this = this;
				_this.numScroll('itemImg1', DeviceGjCounts.DeviceCount);
				_this.numScroll('itemImg2', DeviceGjCounts.GlAbnormalCount);
				_this.numScroll('itemImg3', DeviceGjCounts.GyAbnormalCount);
				_this.numScroll('itemImg4', DeviceGjCounts.QianyaCount);
				_this.numScroll('itemImg5', DeviceGjCounts.WenduCount);
				_this.numScroll('itemImg6', DeviceGjCounts.LdAbnormalCount);
				_this.numScroll('itemImg7', DeviceGjCounts.SanXiangBphcount);
				_this.numScroll('itemImg8', DeviceGjCounts.WeihuCount);
			},

			// 指定图表的配置项和数据
			option_echart(name, value) {
				let _this = this;
				return {
					color: [new Echarts.graphic.LinearGradient(0, 0, 0, 1,
						[{
								offset: 0,
								color: '#0996f6'
							},
							{
								offset: 1,
								color: '#01f6f6'
							}
						]
					), 'rgba(80,150,224,0)'],
					series: [{
						name: '异常类型及次数统计',
						type: 'pie',
						radius: ['65%', '90%'],
						// label: {
						// 	normal: {
						// 		show: false,
						// 		position: 'center'
						// 	}
						// },
						hoverAnimation: false,
						silent: true,
						label: {
							normal: {
								show: true,
								position: 'center',
								formatter: () => {
									return _this.getEchartData(name, value).length > 1 ? _this.getEchartData(
										name, value)[0].value : 0
								},
								textStyle: {
									fontSize: 20,
									color: '#00c4FF'
								}
							}
						},
						data: _this.getEchartData(name, value)
					}]
				};
			},

			// 计算图表数据
			getEchartData(name, value) {
				let _this = this;
				let otherSum = _this.DeviceGjCounts.GlAbnormalCount + _this.DeviceGjCounts.LdAbnormalCount + _this
					.DeviceGjCounts.QianyaCount + _this.DeviceGjCounts.GyAbnormalCount;
				let otherArr = [];
				if (value > 0) {
					otherArr.push({
						name,
						value
					})
				}
				otherArr.push({
					name: "其他异常",
					value: otherSum
				})
				return otherArr;
			},

			/**
			 * 告警占比
			 * @@param data
			 */
			GetAbTypeZbEchartsData(data) {
				let _this = this,
					yAxis_data = [],
					series = [];
				data.forEach((item, index) => {
					yAxis_data.push(item.name);
					series.push({
						name: item.name,
						value: item.value
					});
				})

				_this.$nextTick(function() {
					_this.GetAbTypeZbOption(yAxis_data, series);
				});
			},
			GetAbTypeZbOption(yAxis_data, series) {
				let _this = this;
				let myChart = Echarts.init(document.getElementById('echartRightTop'));
				let option = {
					tooltip: {
						trigger: 'item',
						formatter: "{a} <br/>{b}: {c} ({d}%)"
					},
					color: ['#3fecff', '#4c63f2', '#ed5400', '#7351e3', '#ff4873', '#fdd100'],
					series: [{
						name: '异常类型及次数统计',
						type: 'pie',
						radius: ['35%', '50%'],
						label: {
							normal: {
								formatter: '{b} {c}\n{per|{d}%}',
								rich: {
									b: {
										fontSize: 16,
										lineHeight: 33,
									},
									hr: {
										borderColor: '#00c4ff',
										width: '100%',
										borderWidth: 0.5,
										height: 0
									},
									per: {
										color: '#eee',
										padding: [2, 4],
										borderRadius: 2
									}
								}
							}
						},
						data: series
					}]
				};
				myChart.setOption(option);

				window.addEventListener('resize', function() {
					myChart.resize()
				})

				myChart.on('click', function(param) {
					_this.popupClick('loadDeviceAbList', 2, param.name);
				});
			},

			// 漏电异常次数统计图表
			GetLdAbnormalCountEchartsData(ldlistN, ldlistV) {
				let _this = this;
				_this.GetLdAbnormalCountOption(ldlistN, ldlistV);
			},
			GetLdAbnormalCountOption(ldlistN, ldlistV) {
				let _this = this;
				let myChart = Echarts.init(document.getElementById('echartLeftBottom'));
				let option = {
					tooltip: {
						trigger: 'item',
					},
					calculable: true,
					xAxis: {
						type: 'category',
						axisTick: {
							alignWithLabel: true
						},
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						},
						axisLabel: {
							interval: 0,
							fontSize: 12
						},
						data: ldlistN
					},
					yAxis: {
						name: "",
						offset: -5,
						nameTextStyle: {
							color: "#FFFFFF"
						},
						axisLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: '#fff'
							}
						}
					},
					series: [{
							name: '异常次数',
							type: 'bar',
							barCategoryGap: '70%',
							itemStyle: {
								color: new Echarts.graphic.LinearGradient(0, 0, 0, 1,
									[{
											offset: 0,
											color: '#0996f6'
										},
										{
											offset: 1,
											color: '#6f08d9'
										}
									]
								)
							},
							data: ldlistV,
						},
						{
							type: 'line',
							itemStyle: {
								color: "#FFF"
							},
							data: ldlistV
						}
					]
				};
				myChart.setOption(option);

				window.addEventListener('resize', function() {
					myChart.resize()
				})

				myChart.on('click', function(param) {
					_this.popupClick('LoadDeviceLoudianAb', 2, '漏电异常次数统计', param.name);
				});
			},

			// 过压异常统计数据图表
			GetGyAbnormalCountEchartsData(gylistN, gylistV) {
				let _this = this;
				_this.GetGyAbnormalCountOption(gylistN, gylistV);
			},
			GetGyAbnormalCountOption(gylistN, gylistV) {
				let _this = this;
				let myChart = Echarts.init(document.getElementById('echartRightBottom'));
				let option = {
					tooltip: {
						trigger: 'axis'
					},
					color: ['#00c6ff'],
					xAxis: {
						type: 'category',
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						},
						axisLabel: {
							interval: 0,
							fontSize: 12
						},
						data: gylistN
					},
					yAxis: {
						axisLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: '#fff'
							}
						}
					},
					series: [{
						name: '过压异常',
						type: 'bar',
						barCategoryGap: '70%',
						label: {
							show: true,
							position: 'top',
							color: "#000000",
							backgroundColor: "#ffe400",
							padding: [2, 5, 2, 5]
						},
						data: gylistV,
					}]
				};
				myChart.setOption(option);

				window.addEventListener('resize', function() {
					myChart.resize()
				})

				myChart.on('click', function(param) {
					_this.popupClick('LoadDeviceGuoyaAb', 2, '过压异常及次数统计', param.name);
				});
			},

			// 数字翻牌器
			numScroll(id, maxNum, time = 1000) {
				var numDom = document.getElementById(id)
				var numInit = 0
				var addNum = maxNum / (time / 10)
				var minTime = time / maxNum
				var t = setInterval(function() {
					if (numInit >= maxNum) {
						clearInterval(t)
						t = null;
						if (numDom) {
							numDom.innerText = maxNum;
						}
					} else {
						numInit += addNum
						if (numDom) {
							numDom.innerText = Math.round(numInit);
						}
					}
				}, 10)
			},

			// 弹窗
			popupClick(type, status, name = '', deviceCode = '', typeState = 0) {
				let _this = this;
				_this.popupState = true;
				_this.pageIndex = 1;
				_this.pageSize = 10;
				_this.popupStatus = status;
				_this.popupType = type;
				_this.popupTitle = name;

				_this.totalCount = 0;
				_this.LoadBjDeviceLists = [];

				if (type == 'abnormal') _this.Abnormal();
				else if (type == 'loadDeviceAbList') {
					if (name == '温度异常') {
						_this.TypeName = name.slice(0, 1);
					} else {
						_this.TypeName = name.slice(0, 2);
					}
					_this.LoadDeviceAbList();
				} else if (type == 'getAbTypeDataList') {
					if (deviceCode) {
						_this.DeviceCode = deviceCode;
						_this.TypeName = '';
					} else if (name) {
						_this.DeviceCode = '';
						if (name == '温度异常') {
							_this.TypeName = name.slice(0, 1);
						} else if (name == '三相不平衡') {
							_this.TypeName = name.slice(2, 5);
						} else {
							_this.TypeName = name.slice(0, 2);
						}
					} else {
						_this.popupTitle = '全部告警';
					}
					_this.GetAbTypeDataList();
				} else if (type == 'LoadDeviceLoudianAb') {
					// 这里的deviceCode是时间 2021-03-15
					_this.AbnormalDate = deviceCode;
					_this.LoadDeviceLoudianAb();
				} else if (type == 'LoadDeviceGuoyaAb') {
					// 这里的deviceCode是时间 2021-03-15
					_this.AbnormalDate = deviceCode;
					_this.LoadDeviceGuoyaAb();
				} else if (type == 'GetDeviceList') {
					_this.GetDeviceList();
				}
				// else if (type == 'getDeviceTypeList') {
				// 	_this.typeState = typeState;
				// 	_this.GetDeviceTypeList();
				// } else if (type == 'getAbData') _this.GetAbData();
				// else if (type == 'loadDateOperationRecord') _this.LoadDateOperationRecord();
				// else if (type == 'getAbTjDataList') {
				// 	_this.typeState = typeState;
				// 	_this.GetAbTjDataList();
				// } else if (type == 'getNhDetail') _this.GetNhDetail();
				// else if (type == 'getNhYuZhDetail') _this.GetNhYuZhDetail();
				// else if (type == 'getNhFenshiData') _this.GetNhFenshiData();
				// else if (type == 'getYearNhDetail') _this.GetYearNhDetail();

			},

			// LoadDeviceAbList
			LoadDeviceAbList() {
				let _this = this;
				api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'ShowData/Device/GetAbTypeDataList',
						data: {
							CompanyCode: Cookies.get('ros_CompanyCode'),
							DepartmentCode: Cookies.get('ros_DepartmentCode'),
							GroupCode: Cookies.get('ros_GroupCode'),
							isAdmin: Cookies.get('ros_isAdmin'),
							pageIndex: _this.pageIndex,
							pageSize: _this.pageSize,
							DataType: _this.TypeName
						},
					}).then(function(res) {
						if (res.data.Code == 0) {
							_this.totalCount = res.data.TotalCount;
							_this.LoadBjDeviceLists = res.data.Data;
						}
					})
					.catch(err => { // 请求失败处理
						console.log(err);
					});

			},

			// GetAbTypeDataList
			GetAbTypeDataList() {
				let _this = this;
				api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'ShowData/Device/GetAbTypeDataList',
						data: {
							CompanyCode: Cookies.get('ros_CompanyCode'),
							DepartmentCode: Cookies.get('ros_DepartmentCode'),
							GroupCode: Cookies.get('ros_GroupCode'),
							isAdmin: Cookies.get('ros_isAdmin'),
							DeviceCode: _this.DeviceCode,
							pageIndex: _this.pageIndex,
							pageSize: _this.pageSize,
							DataType: _this.TypeName
						},
					}).then(function(res) {
						if (res.data.Code == 0) {
							_this.totalCount = res.data.TotalCount;
							_this.LoadBjDeviceLists = res.data.Data;
						}
					})
					.catch(err => { // 请求失败处理
						console.log(err);
					});
			},

			// 获取漏电异常列表
			LoadDeviceLoudianAb() {
				let _this = this;
				api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'ShowData/Device/LoadDeviceLoudianAb',
						data: {
							CompanyCode: Cookies.get('ros_CompanyCode'),
							DepartmentCode: Cookies.get('ros_DepartmentCode'),
							GroupCode: Cookies.get('ros_GroupCode'),
							isAdmin: Cookies.get('ros_isAdmin'),
							Dates: _this.AbnormalDate,
							pageIndex: _this.pageIndex,
							pageSize: _this.pageSize,
						},
					}).then(function(res) {
						if (res.data.Code == 0) {
							_this.totalCount = res.data.TotalCount;
							_this.LoadBjDeviceLists = res.data.Data;
						}
					})
					.catch(err => { // 请求失败处理
						console.log(err);
					});

			},

			// 加载过压异常列表
			LoadDeviceGuoyaAb() {
				let _this = this;
				api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'ShowData/Device/LoadDeviceGuoyaAb',
						data: {
							CompanyCode: Cookies.get('ros_CompanyCode'),
							DepartmentCode: Cookies.get('ros_DepartmentCode'),
							GroupCode: Cookies.get('ros_GroupCode'),
							isAdmin: Cookies.get('ros_isAdmin'),
							Dates: _this.AbnormalDate,
							pageIndex: _this.pageIndex,
							pageSize: _this.pageSize,
						},
					}).then(function(res) {
						if (res.data.Code == 0) {
							_this.totalCount = res.data.TotalCount;
							_this.LoadBjDeviceLists = res.data.Data;
						}
					})
					.catch(err => { // 请求失败处理
						console.log(err);
					});
			},

			// 设备列表
			GetDeviceList() {
				let _this = this;
				api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'ShowData/Device/GetDevicelist',
						data: {
							CompanyCode: Cookies.get('ros_CompanyCode'),
							DepartmentCode: Cookies.get('ros_DepartmentCode'),
							GroupCode: Cookies.get('ros_GroupCode'),
							isAdmin: Cookies.get('ros_isAdmin'),
							pageIndex: _this.pageIndex,
							pageSize: _this.pageSize,
						},
					}).then(function(res) {
						if (res.data.Code == 0) {
							_this.totalCount = res.data.TotalCount;
							_this.LoadBjDeviceLists = res.data.Data;
						}
					})
					.catch(err => { // 请求失败处理
						console.log(err);
					});
			},

			// 切换背景色
			switchClick(theme) {
				let _this = this;
				_this.selectTheme = theme;

				if (theme.stateType) {
					document.getElementById('main').style.backgroundColor = '';
					document.getElementById('main').style.backgroundImage = `url(${theme.image})`;
				} else {
					document.getElementById('main').style.backgroundImage = ``;
					document.getElementById('main').style.backgroundColor = theme.color;
				}

				// 本地存储首页主题
				localStorage.setItem("theme", JSON.stringify(theme));

			},

			DeviceChange(e) {
				let _this = this;
				_this.pageIndex = e;
				_this.ReloadFunt();
			},
			DeviceSizeChange(e) {
				let _this = this;
				_this.pageIndex = 1;
				_this.pageSize = e;
				_this.ReloadFunt();
			},

			ReloadFunt() {
				let _this = this;
				switch (_this.popupType) {
					case 'abnormal':
						_this.Abnormal();
						break;
					case 'loadDeviceAbList':
						_this.LoadDeviceAbList();
						break;
					case 'getAbTypeDataList':
						_this.GetAbTypeDataList();
						break;
					case 'LoadDeviceLoudianAb':
						_this.LoadDeviceLoudianAb();
						break;
					case 'LoadDeviceGuoyaAb':
						_this.LoadDeviceGuoyaAb();
						break;
					case 'GetDeviceList':
						_this.GetDeviceList();
						break;
				}
			},

			// 返回
			logout() {
				let _this = this;
				// 清除
				Cookies.set('ros_CompanyCode', '');
				Cookies.set('ros_DepartmentCode', '');
				Cookies.set('ros_GroupCode', '');
				Cookies.set('ros_isAdmin', '');
				_this.$router.push({
					name: 'index'
				})
			},

		},
		filters: {
			formDate: function(dateForm) {
				if (!dateForm) {
					return "";
				} else {
					var dateee = new Date(dateForm).toJSON();
					var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
						/\.[\d]{3}Z/, '');
					return date;
				}
			}
		}
	}
</script>

<style scoped="scoped">
	/**地图相关样式*/

	/deep/.mapTypeBox {
		width: 100px;
		height: 60px;
		background-image: url("../../../assets/service_center/echartsPage/normal.png");
		background-repeat: no-repeat;
		background-size: 100%;
		cursor: pointer;
	}

	/deep/.mapTypeBoxEarth {
		width: 100px;
		height: 60px;
		background-image: url("../../../assets/service_center/echartsPage/earth.png");
		background-repeat: no-repeat;
		background-size: 100%;
		cursor: pointer;
	}

	/deep/.isFull1 {
		width: 25px;
		height: 25px;
		cursor: pointer;
		background-image: url("../../../assets/service_center/echartsPage/full.png");
		background-repeat: no-repeat;
		background-size: 100%;
		position: absolute;
		left: 10px;
		bottom: 10px;
	}

	/deep/ .fullScreen {
		position: absolute !important;
		width: 100% !important;
		height: 100% !important;
		z-index: 999 !important;
	}

	/deep/ .anchorBL {
		display: none;
	}

	/deep/ .BMap_noprint {
		background-size: 100%;
	}

	.user-top-list-page>>>.ivu-page-item,
	.user-top-list-page>>>.ivu-page-prev,
	.user-top-list-page>>>.ivu-page-next,
	.user-top-list-page>>>.ivu-select-selection,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		background-color: rgba(255, 255, 255, 0);
		min-width: 1.2vw;
		height: 1.2vw;
		line-height: 1.2vw;
		border-radius: 3px;
	}

	.user-top-list-page>>>.ivu-page-item>a,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		color: rgb(200, 200, 200);
		font-size: 0.6vw;
	}

	.user-top-list-page>>>.ivu-page-item-active a,
	.ivu-page-item-active:hover a {
		color: #2d8cf0;
	}

	.user-top-list-page>>>.ivu-select-selection,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		border: 0.05vw solid rgba(255, 255, 255, 0.2);
	}

	.user-top-list-page>>>.ivu-select-selected-value,
	.user-top-list-page>>>.ivu-page-options-elevator {
		color: rgba(255, 255, 255, 0.6);
	}
</style>
<style src="./indexc.css" scoped>
</style>
